import { put, takeEvery } from 'redux-saga/effects';
import { ENDPOINT } from '../../services/apiUrls';
import { ResponseGenerator } from './common';
import createApiInstance from '../../services/api';
import { BASE_API_URL } from '../../config';
import {
  fetchLeadsData,
  getLeadId,
  leadsLoadingState,
  saveLeadData,
  updateLead,
  uploadDocument,
  fetchGSTData,
  deleteDocument,
  saveUserInfo,
  getDocuments,
  fetchGSTInfo,
  sendUserInfo,
} from '../slices/leads';

// Dynamically create the API instance with the base URL
const api = createApiInstance(BASE_API_URL); // Replace BASE_API_URL with the dynamic value you have

function* generateLeadId(actions: any) {
  yield put(leadsLoadingState({ loaderState: true }));

  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.LEADS.generateLead,
      data: actions.payload.data,
    });

    actions.payload.callback && actions.payload.callback(response);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  } finally {
    yield put(leadsLoadingState({ loaderState: false }));
  }
}

function* updatingLead(actions: any) {
  yield put(leadsLoadingState({ loaderState: true }));

  try {
    const response: ResponseGenerator = yield api.request({
      method: `PATCH`,
      url: ENDPOINT.LEADS.updateLead + '/' + actions.payload.leadId,
      data: actions.payload.data,
    });

    actions.payload.callback && actions.payload.callback(response);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  } finally {
    yield put(leadsLoadingState({ loaderState: false }));
  }
}

function* fetchUserLeadsDetails(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: `${ENDPOINT.CREDIT_REPORT.creditDetails}/${actions.payload.phone}`,
    });
    actions.payload.callback && actions.payload.callback(response);
    if (response?.data?.leads?.length)
      yield put(saveLeadData(response?.data?.leads || []));
    yield put(saveUserInfo(response?.data || {}));
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  } finally {
  }
}

function* uploadDocuments(actions: any) {
  try {
    const response: ResponseGenerator = yield api.post(
      `${ENDPOINT.LENDERS.uploadDocument(actions.payload.phone)}?documentType=${
        actions.payload.documentType
      }`,
      actions.payload.files,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    actions.payload.callback(response);
  } catch (error: any) {
    actions.payload.callback(error.response);
  }
}

function* deleteDocuments(actions: any) {
  try {
    const response: ResponseGenerator = yield api.delete(
      ENDPOINT.LENDERS.deleteDocument(actions.payload.phone, actions.payload.id)
    );
    if (response.status) {
      actions.payload.callback(true);
    } else {
      actions.payload.callback(false);
    }
  } catch {
    actions.payload.callback(false);
  }
}

function* fetchGSTDetails(actions: any) {
  let url = `${ENDPOINT.LEADS.gstData}/${actions.payload.phone}`;

  if (actions?.payload?.gst) {
    url += `/gst?gstin=${actions.payload.gst}`;
  }

  const headers: any = {};
  if (actions.payload?.token) {
    headers['Authorization'] = actions.payload.token;
  }

  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url,
      headers,
    });
    actions.payload.callback && actions.payload.callback(response);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  } finally {
  }
}

function* getLeadUploadDocuments(actions: any) {
  let url = ENDPOINT.LENDERS.getDocuments(actions.payload.phone);

  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url,
    });
    if (response.status) {
      actions.payload.callback && actions.payload.callback(response.data);
    } else {
      actions.payload.callback && actions.payload.callback(false);
    }
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  } finally {
  }
}

function* getGSTInfo(actions: any) {
  let url = `${ENDPOINT.LEADS.gstInfo}`;

  if (actions?.payload?.gst) {
    url += `?gstin=${actions.payload.gst}`;
  }

  const headers: any = {};
  if (actions.payload?.token) {
    headers['Authorization'] = actions.payload.token;
  }

  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url,
      headers,
    });
    actions.payload.callback && actions.payload.callback(response);
  } catch (error) {
    actions.payload.callback(error);
    console.log(error);
  } finally {
  }
}

function* sendUserDetails(actions: any) {
  let url = `${ENDPOINT.LEADS.sendUserInfo.replace('{userNumber}', actions.payload.phone)}`;

  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url,
    });
    actions.payload.callback && actions.payload.callback(response);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  } finally {
  }
}

export default function* root() {
  yield takeEvery(getLeadId.type, generateLeadId);
  yield takeEvery(updateLead.type, updatingLead);
  yield takeEvery(fetchLeadsData.type, fetchUserLeadsDetails);
  yield takeEvery(uploadDocument.type, uploadDocuments);
  yield takeEvery(deleteDocument.type, deleteDocuments);
  yield takeEvery(fetchGSTData.type, fetchGSTDetails);
  yield takeEvery(fetchGSTInfo.type, getGSTInfo);
  yield takeEvery(sendUserInfo.type, sendUserDetails);
  yield takeEvery(getDocuments.type, getLeadUploadDocuments);
}
